module.exports = __webpack_public_path__ + "img/tool.d68b9b61.svg";